import type { Icon as SvgIconName } from "./icon";

export type StickerIcon =
  | "flag"
  | "check_mark"
  | "dot"
  | "star"
  | "question_mark"
  | "exclamation_mark";

export type StickerColor = "red" | "orange" | "yellow" | "blue" | "purple" | "green";

export interface StickerType {
  icon: StickerIcon;
  color: StickerColor;
  label: string;
}

/**
 * Identity of a sticker on a card. Label is denormalized (read from the
 * sticker-types store via {@link findStickerType}) so renames stay consistent.
 */
export type Sticker = Pick<StickerType, "icon" | "color">;

export const stickerSvgIcon: Record<StickerIcon, SvgIconName> = {
  flag: "sticker/flag",
  check_mark: "sticker/checkmark",
  dot: "sticker/dot",
  star: "sticker/star",
  question_mark: "sticker/question-mark",
  exclamation_mark: "sticker/exclamation-mark",
};

export function stickersEqual(a: Sticker | null, b: Sticker | null): boolean {
  if (!a || !b) return a === b;
  return a.icon === b.icon && a.color === b.color;
}
